<div class="alert alert-primary" role="alert">
  <div style="display:flex;flex-flow:row">
    <div>
      Welcome to the User Group Manager. Please treat this with care as it controls the security of the platform.
    </div>
  </div>
</div>
<div>
  <div>
    <button mat-raised-button color="primary" (click)="createGroup()">New User Group</button>&nbsp;&nbsp;
  </div>
  <div>
    <div *ngFor="let group of groups; let i = index">
      <app-user-group [group]="group" (onClick)="action($event)" [preview]="true"></app-user-group>
    </div>
  </div>
</div>
